<template>
    <div class="test">
        <div v-bind:style = "{color: activeColor}">
            <h1>{{currentJpnChar}}</h1>
        </div>
        <input type="text" v-model="userIn" v-on:keyup.enter="enterHit" id="tboxInput">
        <button v-on:click="enterHit()">Next</button>
    </div>    
</template>

<script>

    export default {
        name: 'test',
        data() {
            return {
                activeColor: 'black',
                title: 'Hello World',
                currentJpnChar: "か",
                currentEngChar: "ka",
                userIn: "",
                user: {
                    firstName: 'Taco',
                    lastName: 'Bell'
                },
                characters: [
                    {eng: 'ka', jpn: 'か'},
                    {eng: 'ke', jpn: 'け'},
                    {eng: 'ku', jpn: 'く'},
                    {eng: 'ki', jpn: 'き'},
                    {eng: 'ko', jpn: 'こ'}
                ]
            }
        },

        methods: {
            enterHit: function(){
                //validate
                if(this.userIn == this.currentEngChar)
                {
                    this.activeColor = "black";
                    var i = Math.floor(Math.random() * 5);
                    this.currentJpnChar = this.characters[i].jpn;
                    this.currentEngChar = this.characters[i].eng;
                    this.userIn = "";
                }
                else
                {
                    this.activeColor = "red";
                    this.userIn = "";
                }

            },

            getCharacters: function(){
                
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/test.vue